import { Injectable } from "@angular/core";
import { catchError, from, map, mergeMap, of } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as trackingActions from "./tracking.actions";
import * as errorActions from "../../core/error/ngrx/error.actions";
import { DataService } from "src/app/supabase/services/data.service";

@Injectable()
export class TrackingEffects {
  constructor(private actions$: Actions, private dataService: DataService) {}
  public id: any;

  getTrackings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(trackingActions.getTrackings),
      mergeMap(() =>
        from(this.dataService.getTrackings()).pipe(
          map((trackings) => trackingActions.getTrackingsSuccess({ trackings })),
          catchError((error) => of(errorActions.handleError({error: "Die Verfolgungen konnten nicht geladen werden.", showToast: false, exception: error  })))
        )
      )
    )
  );

  addTracking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(trackingActions.upsertTracking),
      mergeMap(({ tracking }) =>
        from(this.dataService.addTrackingHttpPlugin(tracking)).pipe(
          map((tracking) => trackingActions.upsertTrackingSuccess({ tracking })),
          catchError((error) => of(errorActions.handleError({error: "Die Verfolgung konnte nicht erstellt werden.", exception: error})))
        )
      )
    )
  );

  deleteTracking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(trackingActions.deleteTracking),
      mergeMap(({ tracking }) =>
        from(this.dataService.deleteTracking(tracking)).pipe(
          map(() => trackingActions.deleteTrackingSuccess({ tracking })),
          catchError((error) => of(errorActions.handleError({error: "Die Verfolgung konnte nicht gelöscht werden.", exception: error})))
        )
      )
    )
  );

  getTrackingsByAppointmentId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(trackingActions.getTrackingsByAppointmentId),
      mergeMap(({ appointmentId }) =>
        from(this.dataService.getTrackingsByAppointmentId(appointmentId)).pipe(
          map((trackings) => trackingActions.getTrackingsByAppointmentIdSuccess({ trackings })),
          catchError((error) => of(errorActions.handleError({error: "Die Verfolgungen konnten nicht geladen werden.", showToast: false, exception: error})))
        )
      )
    )
  );

  upsertTrackings$ = createEffect(() =>
    this.actions$.pipe(
        ofType(trackingActions.replaceTrackings),
        mergeMap(({ oldTrackings, newTrackings }) =>
            from(this.dataService.replaceTrackings(oldTrackings, newTrackings)).pipe(
                map((trackings) => trackingActions.replaceTrackingsSuccess({ trackings })),
                catchError((error) => of(errorActions.handleError({error: "Die Verfolgungen konnten nicht aktualisiert werden.", exception: error})))
            )
        )
    )
);
}
